<template>
    <div>
        <div class="tbfh">
            <div class="fjsf bit-center-wrap" @click="$nav.back()">
                <i class="el-icon-arrow-left" style="color: rgb(170, 170, 170);"></i>
                <span class="ted">
                    <font dir="auto" style="vertical-align: inherit;">
                        <font dir="auto" style="vertical-align: inherit;">订金</font>
                    </font>
                </span>
            </div>
        </div>

        <div class="bit-center-wrap">
            <div class="ag-top">
                <div class="zblx">交易类型</div>
                <el-select placeholder="请选择" style="width: 220px;">
                </el-select>
            </div>
            <div class="infosty bg-main">
                <div class="MetaTrader5-bottom-content">
                    <div class="trend-head">
                        <div class="column"> 帐户角色 </div>
                        <div class="column"> 交易类型 </div>
                        <div class="column"> 账户类型 </div>
                        <div class="column"> 货币类型 </div>
                        <div class="column"> 找零金额 </div>
                        <div class="column"> 交易金额 </div>
                        <div class="column"> 时间 </div>
                    </div>
                    <div class="scroll-wrap">
                        <ul class="trend-body">
                            <li class="row">
                                <div class="column"> 帐户角色 </div>
                                <div class="column"> 交易类型 </div>
                                <div class="column"> 账户类型 </div>
                                <div class="column"> 货币类型 </div>
                                <div class="column"> 找零金额 </div>
                                <div class="column"> 交易金额 </div>
                                <div class="column"> 时间 </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {

    },
    data() {
        return {
            form: {}
        };
    },
    mounted() {

    },
    beforeUnmount() { },
    methods: {

    },
};
</script>
<style lang="scss" scoped>
::v-deep .el-form--label-top .el-form-item__label {
    padding: 0 0 5px 0;
}

::v-deep .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
}

.ag-top {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-bottom: 48px;

    .zblx {
        margin-right: 16px;
        color: #fff
    }
}

.tbfh {
    width: 100%;
    padding: 32px 0;
    background: #090d13;
    margin-bottom: 48px;
}

.fjsf {
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 1.875rem;
}

.bit-center-wrap {
    width: 1360px;
    max-width: 90%;
    margin: 0 auto;
}

.ted {
    font-weight: 700;
    color: #fff;
}

.box {
    width: 1200px;
    margin: 0 auto;
    color: #000;
    margin-bottom: 50px;

    .bg-main {
        background: none;
    }

    .content_TK {
        width: 480px;
        border-radius: 5px;
    }

    .right {
        width: 480px;

        .tips-back {
            margin-top: 48px;
            border-radius: 10px;
            background-color: #171d28;
            padding: 39px 27px 48px;

            .flex-v-c {
                display: flex;
                align-items: center;
                margin-bottom: 28px;

                .notice-img {
                    width: 24px;
                    height: 22px;
                    margin-right: 10px;
                }

                .fsfs {
                    font-size: 20px;
                    font-weight: 700;
                    color: #fff;
                }
            }

            .content {
                margin-top: 28px;
                font-size: 14px;
                font-weight: 400;
                color: hsla(0, 0%, 100%, .8);
                line-height: 30px;
            }
        }
    }
}

.dad {
    height: 100%;
    display: flex;
    align-items: center;
    color: #07ecfe;
    cursor: pointer;
    padding-right: 16px;
}

.sdafasdf {
    cursor: pointer;
    margin-top: 48px;
    width: 100%;
    background: #f0c163 !important;
    border-radius: 4px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    padding: 12px 20px;
}

.infosty {
    overflow-y: auto;
    width: 100%;
}

.titlesty {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #2c313e;
    padding: 0 20px;
    color: #fff;
}

.MetaTrader5-bottom-content {
    text-align: center;
    min-height: 250px;

    .trend-head {
        height: 53px;
        line-height: 53px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 2px;
        color: #fff;
        background-color: #1c222c;

        .column {
            flex: 1;
        }
    }

    .scroll-wrap {
        .trend-body {
            .row {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 2px;
                font-size: 16px;
            }

            .column {
                flex: 1;
                min-height: 53px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        ol,
        ul {
            list-style: none;
        }
    }

    .bottom-more {
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: center;
        color: #888;
    }
}
</style>